export default __webpack_public_path__ + "static/media/drag_image.780dcf98.png";